import { render } from "./tables.vue?vue&type=template&id=00cbe32a&scoped=true"
import script from "./tables.vue?vue&type=script&lang=js"
export * from "./tables.vue?vue&type=script&lang=js"

import "./tables.vue?vue&type=style&index=0&id=00cbe32a&lang=css"
import "./tables.vue?vue&type=style&index=1&id=00cbe32a&scoped=true&lang=css"

import exportComponent from "D:\\Program Files\\vueProject\\sys-bg-sjyy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00cbe32a"]])

export default __exports__